
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: ['navLocalePath', 'navName'],
  emits: ['hide-navigation'],
  setup(props, { emit }) {
    if (props.navLocalePath === undefined) {
      throw new Error('navLocalePath is undefined')
    }

    if (props.navName === undefined) {
      throw new Error('navName is undefined')
    }

    const hideNavi = () => {
      emit('hide-navigation', '')
    }
    return { hideNavi }
  },
})
